import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getInvoiceList,getInvoiceEstimates,getInvoiceDetails,getEstimateDetails,changeInvoiceStatus,updateAdjustment,deleteAdjustment,regenerateInvoice,sendInvoiceMail} from "../actions/account_invoice_action";

export default function AccountInvoiceContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getInvoiceList,getInvoiceEstimates,getInvoiceDetails,getEstimateDetails,changeInvoiceStatus,updateAdjustment,deleteAdjustment,regenerateInvoice,sendInvoiceMail}, dispatch);
}

function mapStateToProps(state) {
    return {
        invoices:state.accountInvoice.invoices,
        estimates:state.accountInvoice.estimates,
        isFetching:state.accountInvoice.isFetching,
        invoiceDetail:state.accountInvoice.invoiceDetail,
        estimateDetail:state.accountInvoice.estimateDetail
    };
}



// WEBPACK FOOTER //
// ./src/containers/account_invoice_container.js